/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { GetQuestionFactory } from "../get-question.factory";
import { normalizeQuestions } from "./normalize-questions-helper";

/**
 * @param {FormReducerDraftState} state 
 * @param {FormReducerAction} action 
 */
export function QuestionReducerActions (state, action) {
    const { type } = action;

    const getQuestion = GetQuestionFactory(state);

    switch (type) {
        case "question/set-property": {
            const { guid, key, value } = action;

            const question = getQuestion(guid);
            question[key] = value;
            if (["step", "position"].includes(key)) {
                state.form.questions = normalizeQuestions(state.form.questions);
            }
            break;
        }

        case "question/add": {
            const question = action?.question;
            const questionIndex = action?.questionIndex;

            const questions = state.form.questions;
            let newQuestions = [];

            if (Array.isArray(questions)) {
                if (questionIndex == null) {
                    questions.push(question);
                } else {
                    questions.splice(questionIndex, 0, question);
                }
                newQuestions = questions.map((question, index) => ({
                    ...question,
                    position: index + 1
                }));
            } else {
                newQuestions = [question];
            }

            state.form.questions = normalizeQuestions(newQuestions);
            break;
        }

        case "question/set": {
            const { questions } = action;
            state.form.questions = normalizeQuestions(questions);
            break;
        }

        default:
            return false;

    }

    return state;
}
